import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { oneOfType, arrayOf, node, func, oneOf, bool } from 'prop-types';
import styled from 'styled-components';
import 'react';
import { stretchClickableStyles } from '../../utils/styleHelpers.js';
import { BUTTON_VARIANTS, BUTTON_SIZES } from './constants.js';
export { BUTTON_SIZES, BUTTON_VARIANTS } from './constants.js';
import { baseStyles, menuItemStyles, sizes, variants } from './styles.js';

var _templateObject;
const Button = /*#__PURE__*/styled.button.withConfig({
  displayName: "button__Button",
  componentId: "sc-1r1hgy4-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), baseStyles, _ref => {
  let {
    fullWidth
  } = _ref;
  return fullWidth && "width: 100%;";
}, _ref2 => {
  let {
    $stretch
  } = _ref2;
  return $stretch && stretchClickableStyles;
}, _ref3 => {
  let {
    isMenuItem
  } = _ref3;
  return isMenuItem && menuItemStyles;
}, _ref4 => {
  let {
    size
  } = _ref4;
  return size && sizes[size];
}, _ref5 => {
  let {
    variant
  } = _ref5;
  return variant && variants[variant];
});
const ButtonProps = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  onClick: func,
  variant: oneOf(Object.values(BUTTON_VARIANTS)),
  size: oneOf(Object.values(BUTTON_SIZES)),
  isMenuItem: bool
};
Button.propTypes = ButtonProps;
Button.defaultProps = {
  variant: BUTTON_VARIANTS.SECONDARY,
  size: BUTTON_SIZES.MEDIUM
};

export { Button };
